export enum RoleEnum {
  ADMINISTRATOR = 'ADMINISTRATOR',
  RESEARCHER = 'RESEARCHER',
  CAREGIVER = 'CAREGIVER',
  PATIENT = 'PATIENT',
  COMPANY = 'COMPANY',
}
